import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {CmsLabelListContainerModel} from '../../../../../../models/aggregates/cms/label';



@Injectable({providedIn: 'root'})

export class CmsLabelListService extends BaseApiTemplateService<CmsLabelListContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'label-lists';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'label-lists';
    this.httpClient = http;
  }
}
